/**
 * Human-readable game titles keyed by URL slug.
 *
 * CommonJS on purpose: the build-time SEO/sitemap scripts require this directly, and the React app
 * re-exports it through src/config/gameDisplayNames.js, so there is one source of truth.
 */
const gameNameMap = {
  fortnite: 'Fortnite',
  'counter-strike-2': 'Counter Strike 2',
  roblox: 'Roblox',
  valorant: 'Valorant',
  warcraft: 'World of Warcraft',
  'clash-royale': 'Clash Royale',
  'anime-vanguards': 'Anime Vanguards',
  'apex-legends': 'Apex Legends',
  'arc-raiders': 'Arc Raiders',
  'arena-breakout': 'Arena Breakout',
  'arena-breakout-infinite': 'Arena Breakout: Infinite',
  battlefield: 'Battlefield',
  'blood-strike': 'Blood Strike',
  'cod-call-of-duty': 'COD Call of Duty',
  'call-of-duty-mobile': 'Call of Duty Mobile',
  cs2: 'Counter Strike 2',
  donutsmp: 'DonutSMP',
  'escape-from-tarkov': 'Escape from Tarkov',
  hypixel: 'Minecraft Hypixel',
  'ea-sports-fc': 'EA Sports FC',
  'ea-sports-fc-mobile': 'EA Sports FC Mobile',
  efootball: 'eFootball',
  'league-of-legends': 'League of Legends',
  minecraft: 'Minecraft',
  'old-school-runescape': 'Old School RuneScape',
  'path-of-exile-2': 'Path of Exile 2',
  'rainbow-six-siege': 'Rainbow Six Siege',
  'rocket-league': 'Rocket League',
  '8-ball-pool': '8 Ball Pool',
  '99-nights-in-the-forest': '99 Nights in the Forest',
  'adopt-me': 'Adopt Me',
  'albion-online': 'Albion Online',
  'all-star-tower-defense-x': 'All Star Tower Defense X',
  'animal-crossing-new-horizons': 'Animal Crossing: New Horizons',
  'anime-defenders': 'Anime Defenders',
  'ark-survival-ascended': 'ARK: Survival Ascended',
  arknights: 'Arknights',
  'ayakashi-rumble': 'Ayakashi Rumble!',
  battlenet: 'Battlenet',
  'black-clover-m': 'Black Clover M',
  'black-desert-online': 'Black Desert Online',
  'bleach-brave-souls': 'Bleach: Brave Souls',
  'blox-fruits': 'Blox Fruits',
  'brawl-stars': 'Brawl Stars',
  'car-parking-multiplayer': 'Car Parking Multiplayer',
  'chaos-zero-nightmare': 'Chaos Zero Nightmare',
  'chocotto-land': 'Chocotto Land',
  'clash-of-clans': 'Clash of Clans',
  'cookie-run-kingdom': 'Cookie Run: Kingdom',
  crunchyroll: 'Crunchyroll',
  'dark-and-darker': 'Dark and Darker',
  darkorbit: 'DarkOrbit',
  dayz: 'DayZ',
  'dead-by-daylight': 'Dead By Daylight',
  'dead-rails': 'Dead Rails',
  'delta-force': 'Delta Force',
  'destiny-2': 'Destiny 2',
  'diablo-4': 'Diablo 4',
  'diablo-immortal': 'Diablo Immortal',
  'digimon-super-rumble': 'Digimon Super Rumble',
  discord: 'Discord',
  'dota-2': 'Dota 2',
  'dragon-ball-legends': 'Dragon Ball Legends',
  'dragon-ball-z-dokkan-battle': 'Dragon Ball Z Dokkan Battle',
  'duet-night-abyss': 'Duet Night Abyss',
  'elden-ring': 'Elden Ring',
  'elder-scrolls-online': 'Elder Scrolls Online',
  'epic-games': 'Epic Games',
  'epic-seven': 'Epic Seven',
  'etheria-restart': 'Etheria: Restart',
  'fallout-76': 'Fallout 76',
  'fate-grand-order': 'Fate/Grand Order',
  'final-fantasy-xiv': 'Final Fantasy XIV',
  fisch: 'Fisch',
  'forza-horizon-5': 'Forza Horizon 5',
  'garena-free-fire': 'Garena Free Fire',
  'genshin-impact': 'Genshin Impact',
  'girls-frontline-2-exilium': 'Girls Frontline 2: Exilium',
  'goddess-of-victory-nikke': 'Goddess of Victory: Nikke',
  'golden-hoyeah': 'Golden HoYeah',
  'granblue-fantasy': 'Granblue Fantasy',
  'grand-roleplay': 'Grand Roleplay',
  'grand-theft-auto-5': 'Grand Theft Auto 5',
  'grow-a-garden': 'Grow a Garden',
  'hay-day': 'Hay Day',
  'honkai-impact-3rd': 'Honkai Impact 3rd',
  'honkai-star-rail': 'Honkai: Star Rail',
  'houchi-shoujo': 'Houchi Shoujo',
  'identity-v': 'Identity V',
  jailbreak: 'Jailbreak',
  'jojo-s-bizarre-adventure-ora-ora-overdrive': "JoJo's Bizarre Adventure: Ora Ora Overdrive",
  'jujutsu-infinite': 'Jujutsu Infinite',
  'jujutsu-kaisen-phantom-parade': 'Jujutsu Kaisen Phantom Parade',
  'kaiju-no-8': 'Kaiju No. 8',
  'king-legacy': 'King Legacy',
  'knight-online': 'Knight Online',
  'knives-out': 'Knives Out',
  'last-island-of-survival': 'Last Island of Survival',
  'last-war-survival': 'Last War: Survival',
  'league-of-legends-wild-rift': 'League of Legends: Wild Rift',
  'livly-island': 'Livly Island',
  'lords-mobile': 'Lords Mobile',
  'lost-ark': 'Lost Ark',
  'madoka-magica-magia-exedra': 'Madoka Magica Magia Exedra',
  'marvel-contest-of-champions': 'Marvel Contest of Champions',
  'marvel-rivals': 'Marvel Rivals',
  metin2: 'Metin2',
  'millennium-war-aigis': 'Millennium War Aigis',
  'mobile-legends': 'Mobile Legends',
  'monster-hunter-now': 'Monster Hunter Now',
  'monster-strike': 'Monster Strike',
  netflix: 'Netflix',
  'new-world': 'New World',
  'one-piece-bounty-rush': 'One Piece Bounty Rush',
  'one-piece-treasure-cruise': 'One Piece Treasure Cruise',
  origin: 'Origin',
  'overwatch-2': 'Overwatch 2',
  'path-of-exile': 'Path of Exile',
  'persona-5-the-phantom-x': 'Persona 5: The Phantom X',
  'plants-vs-brainrots': 'Plants vs Brainrots',
  playstation: 'PlayStation',
  pokecolo: 'Pokecolo',
  'pokecolo-twin': 'Pokecolo Twin',
  'pokemon-go': 'Pokemon Go',
  'pokemon-tcg-pocket': 'Pokemon TCG Pocket',
  'princess-connect-re-dive': 'Princess Connect! Re:Dive',
  'professional-baseball-spirits-a': 'Professional Baseball Spirits A',
  'project-sekai': 'Project SEKAI',
  pubg: 'PUBG',
  'pubg-mobile': 'PUBG Mobile',
  'puzzle-and-dragons': 'Puzzle and Dragons',
  'raid-shadow-legends': 'Raid: Shadow Legends',
  'rainbow-six-siege-x': 'Rainbow Six Siege X',
  'rise-of-kingdoms': 'Rise of Kingdoms',
  'royale-online': 'Royale Online',
  'runescape-3': 'RuneScape 3',
  rust: 'Rust',
  'sd-gundam-g-generation-eternal': 'SD Gundam G Generation ETERNAL',
  'sea-of-thieves': 'Sea of Thieves',
  'seven-knights-re-birth': 'Seven Knights Re:BIRTH',
  shadowverse: 'Shadowverse',
  'silver-and-blood': 'Silver and Blood',
  'sky-children-of-the-light': 'Sky: Children of the Light',
  spotify: 'Spotify',
  'standoff-2': 'Standoff 2',
  'steal-a-brainrot': 'Steal a Brainrot',
  'stella-sora': 'Stella Sora',
  'summoners-war': 'Summoners War',
  'the-finals': 'The Finals',
  'the-forge': 'The Forge',
  'the-seven-deadly-sins': 'The Seven Deadly Sins',
  'throne-and-liberty': 'Throne and Liberty',
  'tower-of-fantasy': 'Tower of Fantasy',
  'ubisoft-connect': 'Ubisoft Connect',
  'uma-musume-pretty-derby': 'Uma Musume Pretty Derby',
  'unveil-the-world': 'unVEIL the world',
  'volleyball-legends': 'Volleyball Legends',
  'war-thunder': 'War Thunder',
  warframe: 'Warframe',
  'wartune-ultra': 'Wartune Ultra',
  'watcher-of-realms': 'Watcher of Realms',
  'where-winds-meet': 'Where Winds Meet',
  'white-cat-project': 'White Cat Project',
  'whiteout-survival': 'Whiteout Survival',
  wolfteam: 'WolfTeam',
  'world-of-tanks': 'World of Tanks',
  'world-of-warcraft': 'World of Warcraft',
  'world-of-warships': 'World of Warships',
  'wow-classic': 'WoW Classic',
  'wow-mists-of-pandaria': 'WoW Mists of Pandaria',
  'wuthering-waves': 'Wuthering Waves',
  xbox: 'Xbox',
  'yo-kai-watch-wibble-wobble': 'Yo-kai Watch: Wibble Wobble',
  'yu-gi-oh-master-duel': 'Yu-Gi-Oh! Master Duel',
  'zenless-zone-zero': 'Zenless Zone Zero',
  zula: 'Zula',
};

module.exports = { gameNameMap };
